module.exports = __webpack_public_path__ + "static/baker-e14e92215aa8cbf2c00d87f4b8c60058.jpg";